import helpers from './modules/helpers';
import equalheight from './modules/equalheight';
import lazyImages from './modules/lazy-image';
import menu from './modules/menu';
import videoBg from './modules/video-bg';
import nextSection from './modules/next-section';
import carousel from './modules/carousel';
import parallax from './modules/parallax';
import parallaxBlock from './modules/parallax-block';
import countUp from './modules/count-up';
import accordion from './modules/accordion';
import gallery from './modules/gallery';
import revealCta from './modules/reveal-cta';
import video from './modules/video';
import checkPreviousSection from './modules/check-previous-section';
import tabs from './modules/tabs';
import select from './modules/select';
import forms from './modules/forms';
import scrollTo from './modules/scrollTo';
import setUserLanguage from './modules/setUserLanguage';
import locateARep from './modules/locate-a-rep';
import scrollbar from './modules/scrollbar';

// set up namespace
const spirax = window.spirax || {
  helpers,
  equalheight,
  lazyImages,
  menu,
  videoBg,
  nextSection,
  carousel,
  parallax,
  parallaxBlock,
  countUp,
  accordion,
  gallery,
  revealCta,
  video,
  checkPreviousSection,
  tabs,
  select,
  forms,
  scrollTo,
  setUserLanguage,
  locateARep,
  scrollbar,
};

// globals to window
window.spirax = spirax;

// run the code.
document.addEventListener('DOMContentLoaded', () => {
  Object.keys(spirax).forEach((module) => {
    if (typeof spirax[module].init === 'function') {
      try {
        spirax[module].init();
      } catch (error) {
        console.error(error);
      }
    }
  });
});
